var map = {
	"./albedo.json": "nxB0",
	"./arataki-itto.json": "8UV1",
	"./ayaka.json": "x9vY",
	"./banners.json": "ot+b",
	"./discontinuedBanners.json": "CYSA",
	"./epitome-eula.json": "9oug",
	"./epitome-keqing.json": "lPdf",
	"./epitome-tartaglia2.json": "n4Ur",
	"./epitome-venti2.json": "zTpB",
	"./epitome-xiao.json": "hV5U",
	"./epitome.json": "qnxk",
	"./eula.json": "2au8",
	"./ganyu.json": "hp57",
	"./hu-tao.json": "S+m6",
	"./kamisato-ayato.json": "/v+c",
	"./kazuha.json": "M1Wn",
	"./keqing.json": "27q9",
	"./klee.json": "MB+J",
	"./noelle.json": "7vTj",
	"./notices/notices.json": "v963",
	"./raiden.json": "4jog",
	"./shenhe.json": "ZR7+",
	"./tartaglia.json": "0TUf",
	"./tartaglia2.json": "3mUZ",
	"./venti.json": "sE8O",
	"./venti2.json": "baNV",
	"./wanderlust-xiao.json": "QKup",
	"./wanderlust.json": "Vit0",
	"./xiao.json": "DFlI",
	"./yae-miko.json": "592U",
	"./yelan.json": "btyv",
	"./zhongli.json": "Ixjp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9z3x";